import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getIsProduction, setIsProduction } from 'rdx/hardware';
import { getInstallerConfig } from 'service/InstallerApp';
import { getCurrentOSBitSystem } from 'utils';

import { getPublicBucketUrl } from '../schemas';

export const useInstallerDownloadLink = (
  os: 'Linux' | 'Windows' | 'Mac',
  windowsBit?: 'x32v2' | 'x64v2',
) => {
  const windowsSuffixes = {
    x32v2: '/installer2_windows_386.msi',
    x64v2: '/installer2_windows_amd64.msi',
  };
  const bitSystem =
    windowsBit || (`${getCurrentOSBitSystem()}v2` as 'x32v2' | 'x64v2');
  const suffix = {
    Linux: '/installer2_linux_amd64.deb',
    Windows: windowsSuffixes[bitSystem],
    Mac: '/installer2_darwin_amd64.pkg',
  };

  const isProduction = useSelector(getIsProduction);
  const dispatch = useDispatch();

  useEffect(() => {
    // @ts-ignore
    getInstallerConfig().then(({ data }) => {
      const config = JSON.parse(data.config ?? {});
      dispatch(setIsProduction(config?.production));
    });
  }, []);

  return getPublicBucketUrl(isProduction).concat(suffix[os]);
};
